import axios from 'axios';
import { isUndefined, isEmpty } from 'lodash';
import { getErrorResponse, handleErrorResponse } from './helper';
import STATUS_CODE from './statusCode';
import store from '../store';
import { updateUserInfo } from '../store/account/actions';
import { getUserToken, parseToken } from '../utils/login';
import localStorage, { MODULES } from '../utils/localStorage';

const myAxios = axios.create({
  timeout: 100 * 1000,
  paramsSerializer: params => {
    return Object.keys(params)
      .map(key => {
        const value = params[key];
        if (value === undefined || value === null) {
          return '';
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .filter(part => part !== '')
      .join('&');
  }
});

myAxios.interceptors.request.use(config => {
  const userToken = getUserToken();
  if (!isEmpty(userToken)) {
    // Update user data in localStorage from token
    const { sub, privilegedAccount } = parseToken(userToken);
    localStorage.setModule(MODULES.USER, {
      privilegedAccount: !!privilegedAccount,
      userName: sub || ''
    });

    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${userToken}`;
  }
  return config;
});

axios.defaultSource = axios.CancelToken.source();

myAxios.interceptors.request.use(config => {
  if (isUndefined(config.cancelToken)) {
    // eslint-disable-next-line no-param-reassign
    config.cancelToken = axios.defaultSource.token;
  }
  return config;
});

export default (config, showErrorTip = true) => {
  return myAxios(config)
    .then(res => {
      const {
        headers: { authorization }
      } = res;
      const token = authorization || getUserToken();
      if (token) {
        store.dispatch(updateUserInfo(token));
      }
      return {
        statusCode: STATUS_CODE.OK,
        data: res.data && res.data.data
      };
    })
    .catch(error => {
      const errorResponse = getErrorResponse(error);
      handleErrorResponse(errorResponse, showErrorTip);
      return errorResponse;
    });
};
